// extracted by mini-css-extract-plugin
module.exports = {"root":"lab-pack-services-page_root__pyA_B"};